import { call, put, takeLatest } from 'redux-saga/effects';
import {
  claimMonsterHashRankSuccess,
  claimMonsterHashRankFailed,
  CLAIM_MONSTER_RANK,
} from '../../actions/monster';
import { callClaimReward } from '../../../app/Profile/2MyAssets/6Rewards/HashChipRewards/index';

function* doClaimMonsterHashRank(action) {
  try {
    const { tokenId, rank, sdk, onSuccess, onError } = action.payload;

    const response = yield call(callClaimReward, tokenId, rank, sdk);

    yield put(claimMonsterHashRankSuccess(response));
    if (onSuccess) {
      yield call(onSuccess, response);
    }
  } catch (error) {
    yield put(claimMonsterHashRankFailed({ error: error.message }));
    if (action.payload.onError) {
      yield call(action.payload.onError, { message: error.message });
    }
  }
}

export default function* watchClaimMonsterHashRank() {
  yield takeLatest(CLAIM_MONSTER_RANK, doClaimMonsterHashRank);
}